"use client"

import { useState, useEffect } from "react"
import { Button } from "@/shared/components/ui/button"
import { ChevronUp } from "lucide-react"

// Throttle function to limit scroll event frequency
const throttle = (func: Function, limit: number) => {
  let inThrottle: boolean
  return function (this: any, ...args: any[]) {
    if (!inThrottle) {
      func.apply(this, args)
      inThrottle = true
      setTimeout(() => inThrottle = false, limit)
    }
  }
}

export default function BackToTop() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const toggleVisibility = () => {
            // Show button when page is scrolled down 300px
            if (window.scrollY > 300) {
                setIsVisible(true)
            } else {
                setIsVisible(false)
            }
        }

        const throttledToggleVisibility = throttle(toggleVisibility, 16)

        window.addEventListener("scroll", throttledToggleVisibility, { passive: true })

        return () => {
            window.removeEventListener("scroll", throttledToggleVisibility)
        }
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }

    return (
        <>
            {isVisible && (
                <Button
                    onClick={scrollToTop}
                    variant="ghost"
                    className="fixed bottom-8 right-8 z-50 h-12 w-12 rounded-full shadow-lg transition-all hover:scale-110 btn-autumn-primary"
                    style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)', color: 'white' }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #ea580c 0%, #dc2626 100%)'
                        e.currentTarget.style.color = 'white'
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)'
                        e.currentTarget.style.color = 'white'
                    }}
                    size="icon"
                    aria-label="Back to top"
                >
                    <ChevronUp className="h-5 w-5" />
                </Button>
            )}
        </>
    )
}
